import React from "react"
import { Select } from "components-design-system"

// api
import { useGetSponsorTypes } from "api/hooks/admin/useSponsorApi"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"

import { EMA_RWD_OPTIONS_TYPE_MAP } from "constants/authoring"
// import { getEmaRwdOptions } from "../../../hooks/actions/useAuthoringActions"
import { useEmaRwdDropdowns } from "api/hooks/studies/useAuthoringApi"

const RJLookahead = (props) => {
  const [items, setItems] = React.useState([])
  let { id, carbonProps, options, value, onChange, invalid, schema } = props
  const [selectedItem, setSelectedItem] = React.useState(null)
  const { getEmaRwdOptions } = useEmaRwdDropdowns()

  const jpath = id.split(".").slice(1).join("_")

  const { data: sponsors = [] } = useGetSponsorTypes()

  React.useEffect(() => {
    const getOptions = async () => {
      if (EMA_RWD_OPTIONS_TYPE_MAP[id]) {
        const items = await getEmaRwdOptions(id)
        setItems(items)
      } else if (options && options.enumOptions?.length > 0) {
        let newItems = options.enumOptions.map((option) => {
          return { value: option.value, label: option.value }
        })
        setItems(newItems)
      } else if (schema?.options) {
        setItems(schema.options)
      }
    }

    getOptions()
  }, [])

  const onSetItems = (items) => {
    let newItems = items?.map((option) => {
      return { value: option.name, label: option.name }
    })
    setItems(newItems)
  }

  React.useEffect(() => {
    if (id === "root.protocol.contact_information.sponsor" && sponsors) {
      onSetItems(sponsors)
    }
  }, [sponsors])

  React.useEffect(() => {
    if (value && typeof value !== "object") {
      setSelectedItem(value)
    }
  }, [value])

  const handleChange = (val) => {
    console.log("Lookahead React.useEffect >> onChange")
    onChange(val)
  }

  const variant = invalid ? "error" : undefined

  return (
    <Select
      id={jpath + "-field"}
      allowClear
      status={variant}
      disabled={carbonProps?.disabled}
      placeholder={carbonProps?.placeholder || ""}
      value={selectedItem}
      onChange={handleChange}
      options={items}
    />
  )
}

export default InputWrapper(RJLookahead)
